/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ListingBookmark } from '../model';
// @ts-ignore
import { ListingBookmarkRequest } from '../model';
// @ts-ignore
import { ListingEnquiry } from '../model';
// @ts-ignore
import { ListingEnquiryCreateRequest } from '../model';
// @ts-ignore
import { ListingRead } from '../model';
// @ts-ignore
import { PaginatedListingReadList } from '../model';
// @ts-ignore
import { ValidationError } from '../model';
/**
 * PublicMarketplaceListingApi - axios parameter creator
 * @export
 */
export const PublicMarketplaceListingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Create or update a Bookmark against the Listing.
         * @param {string} listingId 
         * @param {ListingBookmarkRequest} listingBookmarkRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketplaceListingBookmarkCreate: async (listingId: string, listingBookmarkRequest: ListingBookmarkRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'listingId' is not null or undefined
            assertParamExists('marketplaceListingBookmarkCreate', 'listingId', listingId)
            // verify required parameter 'listingBookmarkRequest' is not null or undefined
            assertParamExists('marketplaceListingBookmarkCreate', 'listingBookmarkRequest', listingBookmarkRequest)
            const localVarPath = `/v2/marketplace/listing/{listing_id}/bookmark`
                .replace(`{${"listing_id"}}`, encodeURIComponent(String(listingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listingBookmarkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Create a new Enquiry for a Listing.
         * @param {string} listingId 
         * @param {ListingEnquiryCreateRequest} listingEnquiryCreateRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketplaceListingEnquiryCreate: async (listingId: string, listingEnquiryCreateRequest: ListingEnquiryCreateRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'listingId' is not null or undefined
            assertParamExists('marketplaceListingEnquiryCreate', 'listingId', listingId)
            // verify required parameter 'listingEnquiryCreateRequest' is not null or undefined
            assertParamExists('marketplaceListingEnquiryCreate', 'listingEnquiryCreateRequest', listingEnquiryCreateRequest)
            const localVarPath = `/v2/marketplace/listing/{listing_id}/enquiry`
                .replace(`{${"listing_id"}}`, encodeURIComponent(String(listingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listingEnquiryCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary The public endpoint for retrieving all the current public listings.
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {boolean} [anonymous] Filter anonymous listings.
         * @param {string} [bookmark] Filter by Bookmark Type. Choices: NEW, IGNORE, TRADE, WATCH. Multiple values must be comma separated
         * @param {string} [network] Filter by Network id. Multiple values must be comma separated. Use &#x60;all&#x60; to return Listings that are only shared with a Network.
         * @param {string} [org] Filter by Organisation id
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [priceMax] Maximum price
         * @param {string} [priceMin] Minimum price
         * @param {string} [priceType] Filter by price type
         * @param {string} [product] Internal ID of the product
         * @param {string} [quantityMax] Maximum quantity
         * @param {string} [quantityMin] Minimum quantity
         * @param {string} [search] Filter by a set of keywords
         * @param {boolean} [sold] Filter by if the Listing is sold or not
         * @param {'ACT' | 'NSW' | 'NT' | 'QLD' | 'SA' | 'TAS' | 'VIC' | 'WA'} [state] Filter by state of the Listings. Multiple values must be comma separated  * &#x60;ACT&#x60; - Australian Capital Territory * &#x60;NSW&#x60; - New South Wales * &#x60;NT&#x60; - Northern Territory * &#x60;QLD&#x60; - Queensland * &#x60;SA&#x60; - South Australia * &#x60;TAS&#x60; - Tasmania * &#x60;VIC&#x60; - Victoria * &#x60;WA&#x60; - Western Australia
         * @param {string} [stockAge] Filter by Stock Age. Multiple values must be comma separated
         * @param {string} [stockCat] Filter by Stock Categories. Multiple values must be comma separated
         * @param {string} [stockGender] Filter by Stock Gender. Multiple values must be comma separated
         * @param {'BUY' | 'SELL'} [type] Filter by Listing type  * &#x60;SELL&#x60; - For sale * &#x60;BUY&#x60; - Wanted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketplaceListingList: async (aaSource?: string, anonymous?: boolean, auction?: boolean, bookmark?: string, network?: string, org?: string, page?: number, pageSize?: number, priceMax?: string, priceMin?: string, priceType?: string, product?: string, quantityMax?: string, quantityMin?: string, search?: string, sold?: boolean, state?: 'ACT' | 'NSW' | 'NT' | 'QLD' | 'SA' | 'TAS' | 'VIC' | 'WA', stockAge?: string, stockCat?: string, stockGender?: string, type?: 'BUY' | 'SELL', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/marketplace/listing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }

            if (anonymous !== undefined) {
                localVarQueryParameter['anonymous'] = anonymous;
            }

            if (auction !== undefined) {
                localVarQueryParameter['auction'] = auction;
            }

            if (bookmark !== undefined) {
                localVarQueryParameter['bookmark'] = bookmark;
            }

            if (network !== undefined) {
                localVarQueryParameter['network'] = network;
            }

            if (org !== undefined) {
                localVarQueryParameter['org'] = org;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (priceMax !== undefined) {
                localVarQueryParameter['price_max'] = priceMax;
            }

            if (priceMin !== undefined) {
                localVarQueryParameter['price_min'] = priceMin;
            }

            if (priceType !== undefined) {
                localVarQueryParameter['price_type'] = priceType;
            }

            if (product !== undefined) {
                localVarQueryParameter['product'] = product;
            }

            if (quantityMax !== undefined) {
                localVarQueryParameter['quantity_max'] = quantityMax;
            }

            if (quantityMin !== undefined) {
                localVarQueryParameter['quantity_min'] = quantityMin;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sold !== undefined) {
                localVarQueryParameter['sold'] = sold;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (stockAge !== undefined) {
                localVarQueryParameter['stock_age'] = stockAge;
            }

            if (stockCat !== undefined) {
                localVarQueryParameter['stock_cat'] = stockCat;
            }

            if (stockGender !== undefined) {
                localVarQueryParameter['stock_gender'] = stockGender;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint behaves the same as the Public Listing endpoint except for:  1. It is filtered by the Organisation in the path  2. If the Organisation is a Head Org then all Public Listings within it\'s Networks are also returned. 3. Anonymous Listings are filtered out.
         * @summary The public endpoint for retrieving all the current Public Listings filtered by the Org
         * @param {string} orgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {string} [bookmark] Filter by Bookmark Type. Choices: NEW, IGNORE, TRADE, WATCH. Multiple values must be comma separated
         * @param {string} [network] Filter by Network id. Multiple values must be comma separated. Use &#x60;all&#x60; to return Listings that are only shared with a Network.
         * @param {string} [org] Filter by Organisation id
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {number} [priceMax] Filter by pricing using a min and/or max value
         * @param {number} [priceMin] Filter by pricing using a min and/or max value
         * @param {string} [priceType] Filter by price type
         * @param {string} [product] Internal ID of the product
         * @param {string} [quantityMax] Filter by quantity using a min and/or max value
         * @param {string} [quantityMin] Filter by quantity using a min and/or max value
         * @param {string} [search] Filter by a set of keywords
         * @param {boolean} [sold] Filter by if the Listing is sold or not
         * @param {'ACT' | 'NSW' | 'NT' | 'QLD' | 'SA' | 'TAS' | 'VIC' | 'WA'} [state] Filter by state of the Listings. Multiple values must be comma separated  * &#x60;ACT&#x60; - Australian Capital Territory * &#x60;NSW&#x60; - New South Wales * &#x60;NT&#x60; - Northern Territory * &#x60;QLD&#x60; - Queensland * &#x60;SA&#x60; - South Australia * &#x60;TAS&#x60; - Tasmania * &#x60;VIC&#x60; - Victoria * &#x60;WA&#x60; - Western Australia
         * @param {string} [stockAge] Filter by Stock Age. Multiple values must be comma separated
         * @param {string} [stockCat] Filter by Stock Categories. Multiple values must be comma separated
         * @param {string} [stockGender] Filter by Stock Gender. Multiple values must be comma separated
         * @param {'BUY' | 'SELL'} [type] Filter by Listing type  * &#x60;SELL&#x60; - For sale * &#x60;BUY&#x60; - Wanted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketplaceListingOrgList: async (orgId: string, aaSource?: string, bookmark?: string, network?: string, org?: string, page?: number, pageSize?: number, priceMax?: number, priceMin?: number, priceType?: string, product?: string, quantityMax?: string, quantityMin?: string, search?: string, sold?: boolean, state?: 'ACT' | 'NSW' | 'NT' | 'QLD' | 'SA' | 'TAS' | 'VIC' | 'WA', stockAge?: string, stockCat?: string, stockGender?: string, type?: 'BUY' | 'SELL', options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('marketplaceListingOrgList', 'orgId', orgId)
            const localVarPath = `/v2/marketplace/listing/org/{org_id}`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }

            if (bookmark !== undefined) {
                localVarQueryParameter['bookmark'] = bookmark;
            }

            if (network !== undefined) {
                localVarQueryParameter['network'] = network;
            }

            if (org !== undefined) {
                localVarQueryParameter['org'] = org;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (priceMax !== undefined) {
                localVarQueryParameter['price_max'] = priceMax;
            }

            if (priceMin !== undefined) {
                localVarQueryParameter['price_min'] = priceMin;
            }

            if (priceType !== undefined) {
                localVarQueryParameter['price_type'] = priceType;
            }

            if (product !== undefined) {
                localVarQueryParameter['product'] = product;
            }

            if (quantityMax !== undefined) {
                localVarQueryParameter['quantity_max'] = quantityMax;
            }

            if (quantityMin !== undefined) {
                localVarQueryParameter['quantity_min'] = quantityMin;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sold !== undefined) {
                localVarQueryParameter['sold'] = sold;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (stockAge !== undefined) {
                localVarQueryParameter['stock_age'] = stockAge;
            }

            if (stockCat !== undefined) {
                localVarQueryParameter['stock_cat'] = stockCat;
            }

            if (stockGender !== undefined) {
                localVarQueryParameter['stock_gender'] = stockGender;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary The public endpoint for retrieving the latest APPROVED version of the listing, otherwise 404
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketplaceListingRetrieve: async (listingId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'listingId' is not null or undefined
            assertParamExists('marketplaceListingRetrieve', 'listingId', listingId)
            const localVarPath = `/v2/marketplace/listing/{listing_id}`
                .replace(`{${"listing_id"}}`, encodeURIComponent(String(listingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Should only be used when a view count needs to be added for a listing when it is not viewed via the standard GET:/v2/marketplace/listing/{listing_id} request  eg: from an agora embedded widget
         * @summary Add a view event for the listing
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketplaceListingVCreate: async (listingId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'listingId' is not null or undefined
            assertParamExists('marketplaceListingVCreate', 'listingId', listingId)
            const localVarPath = `/v2/marketplace/listing/{listing_id}/v`
                .replace(`{${"listing_id"}}`, encodeURIComponent(String(listingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicMarketplaceListingApi - functional programming interface
 * @export
 */
export const PublicMarketplaceListingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicMarketplaceListingApiAxiosParamCreator(configuration)
    return {
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Create or update a Bookmark against the Listing.
         * @param {string} listingId 
         * @param {ListingBookmarkRequest} listingBookmarkRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketplaceListingBookmarkCreate(listingId: string, listingBookmarkRequest: ListingBookmarkRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListingBookmark>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketplaceListingBookmarkCreate(listingId, listingBookmarkRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Create a new Enquiry for a Listing.
         * @param {string} listingId 
         * @param {ListingEnquiryCreateRequest} listingEnquiryCreateRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketplaceListingEnquiryCreate(listingId: string, listingEnquiryCreateRequest: ListingEnquiryCreateRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListingEnquiry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketplaceListingEnquiryCreate(listingId, listingEnquiryCreateRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary The public endpoint for retrieving all the current public listings.
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {boolean} [anonymous] Filter anonymous listings.
         * @param {string} [bookmark] Filter by Bookmark Type. Choices: NEW, IGNORE, TRADE, WATCH. Multiple values must be comma separated
         * @param {string} [network] Filter by Network id. Multiple values must be comma separated. Use &#x60;all&#x60; to return Listings that are only shared with a Network.
         * @param {string} [org] Filter by Organisation id
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [priceMax] Maximum price
         * @param {string} [priceMin] Minimum price
         * @param {string} [priceType] Filter by price type
         * @param {string} [product] Internal ID of the product
         * @param {string} [quantityMax] Maximum quantity
         * @param {string} [quantityMin] Minimum quantity
         * @param {string} [search] Filter by a set of keywords
         * @param {boolean} [sold] Filter by if the Listing is sold or not
         * @param {'ACT' | 'NSW' | 'NT' | 'QLD' | 'SA' | 'TAS' | 'VIC' | 'WA'} [state] Filter by state of the Listings. Multiple values must be comma separated  * &#x60;ACT&#x60; - Australian Capital Territory * &#x60;NSW&#x60; - New South Wales * &#x60;NT&#x60; - Northern Territory * &#x60;QLD&#x60; - Queensland * &#x60;SA&#x60; - South Australia * &#x60;TAS&#x60; - Tasmania * &#x60;VIC&#x60; - Victoria * &#x60;WA&#x60; - Western Australia
         * @param {string} [stockAge] Filter by Stock Age. Multiple values must be comma separated
         * @param {string} [stockCat] Filter by Stock Categories. Multiple values must be comma separated
         * @param {string} [stockGender] Filter by Stock Gender. Multiple values must be comma separated
         * @param {'BUY' | 'SELL'} [type] Filter by Listing type  * &#x60;SELL&#x60; - For sale * &#x60;BUY&#x60; - Wanted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketplaceListingList(aaSource?: string, anonymous?: boolean, auction?: boolean, bookmark?: string, network?: string, org?: string, page?: number, pageSize?: number, priceMax?: string, priceMin?: string, priceType?: string, product?: string, quantityMax?: string, quantityMin?: string, search?: string, sold?: boolean, state?: 'ACT' | 'NSW' | 'NT' | 'QLD' | 'SA' | 'TAS' | 'VIC' | 'WA', stockAge?: string, stockCat?: string, stockGender?: string, type?: 'BUY' | 'SELL', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListingReadList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketplaceListingList(aaSource, anonymous, auction, bookmark, network, org, page, pageSize, priceMax, priceMin, priceType, product, quantityMax, quantityMin, search, sold, state, stockAge, stockCat, stockGender, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint behaves the same as the Public Listing endpoint except for:  1. It is filtered by the Organisation in the path  2. If the Organisation is a Head Org then all Public Listings within it\'s Networks are also returned. 3. Anonymous Listings are filtered out.
         * @summary The public endpoint for retrieving all the current Public Listings filtered by the Org
         * @param {string} orgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {string} [bookmark] Filter by Bookmark Type. Choices: NEW, IGNORE, TRADE, WATCH. Multiple values must be comma separated
         * @param {string} [network] Filter by Network id. Multiple values must be comma separated. Use &#x60;all&#x60; to return Listings that are only shared with a Network.
         * @param {string} [org] Filter by Organisation id
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {number} [priceMax] Filter by pricing using a min and/or max value
         * @param {number} [priceMin] Filter by pricing using a min and/or max value
         * @param {string} [priceType] Filter by price type
         * @param {string} [product] Internal ID of the product
         * @param {string} [quantityMax] Filter by quantity using a min and/or max value
         * @param {string} [quantityMin] Filter by quantity using a min and/or max value
         * @param {string} [search] Filter by a set of keywords
         * @param {boolean} [sold] Filter by if the Listing is sold or not
         * @param {'ACT' | 'NSW' | 'NT' | 'QLD' | 'SA' | 'TAS' | 'VIC' | 'WA'} [state] Filter by state of the Listings. Multiple values must be comma separated  * &#x60;ACT&#x60; - Australian Capital Territory * &#x60;NSW&#x60; - New South Wales * &#x60;NT&#x60; - Northern Territory * &#x60;QLD&#x60; - Queensland * &#x60;SA&#x60; - South Australia * &#x60;TAS&#x60; - Tasmania * &#x60;VIC&#x60; - Victoria * &#x60;WA&#x60; - Western Australia
         * @param {string} [stockAge] Filter by Stock Age. Multiple values must be comma separated
         * @param {string} [stockCat] Filter by Stock Categories. Multiple values must be comma separated
         * @param {string} [stockGender] Filter by Stock Gender. Multiple values must be comma separated
         * @param {'BUY' | 'SELL'} [type] Filter by Listing type  * &#x60;SELL&#x60; - For sale * &#x60;BUY&#x60; - Wanted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketplaceListingOrgList(orgId: string, aaSource?: string, bookmark?: string, network?: string, org?: string, page?: number, pageSize?: number, priceMax?: number, priceMin?: number, priceType?: string, product?: string, quantityMax?: string, quantityMin?: string, search?: string, sold?: boolean, state?: 'ACT' | 'NSW' | 'NT' | 'QLD' | 'SA' | 'TAS' | 'VIC' | 'WA', stockAge?: string, stockCat?: string, stockGender?: string, type?: 'BUY' | 'SELL', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListingReadList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketplaceListingOrgList(orgId, aaSource, bookmark, network, org, page, pageSize, priceMax, priceMin, priceType, product, quantityMax, quantityMin, search, sold, state, stockAge, stockCat, stockGender, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary The public endpoint for retrieving the latest APPROVED version of the listing, otherwise 404
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketplaceListingRetrieve(listingId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListingRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketplaceListingRetrieve(listingId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Should only be used when a view count needs to be added for a listing when it is not viewed via the standard GET:/v2/marketplace/listing/{listing_id} request  eg: from an agora embedded widget
         * @summary Add a view event for the listing
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketplaceListingVCreate(listingId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketplaceListingVCreate(listingId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PublicMarketplaceListingApi - factory interface
 * @export
 */
export const PublicMarketplaceListingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicMarketplaceListingApiFp(configuration)
    return {
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Create or update a Bookmark against the Listing.
         * @param {string} listingId 
         * @param {ListingBookmarkRequest} listingBookmarkRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketplaceListingBookmarkCreate(listingId: string, listingBookmarkRequest: ListingBookmarkRequest, aaSource?: string, options?: any): AxiosPromise<ListingBookmark> {
            return localVarFp.marketplaceListingBookmarkCreate(listingId, listingBookmarkRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Create a new Enquiry for a Listing.
         * @param {string} listingId 
         * @param {ListingEnquiryCreateRequest} listingEnquiryCreateRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketplaceListingEnquiryCreate(listingId: string, listingEnquiryCreateRequest: ListingEnquiryCreateRequest, aaSource?: string, options?: any): AxiosPromise<ListingEnquiry> {
            return localVarFp.marketplaceListingEnquiryCreate(listingId, listingEnquiryCreateRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary The public endpoint for retrieving all the current public listings.
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {boolean} [anonymous] Filter anonymous listings.
         * @param {string} [bookmark] Filter by Bookmark Type. Choices: NEW, IGNORE, TRADE, WATCH. Multiple values must be comma separated
         * @param {string} [network] Filter by Network id. Multiple values must be comma separated. Use &#x60;all&#x60; to return Listings that are only shared with a Network.
         * @param {string} [org] Filter by Organisation id
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [priceMax] Maximum price
         * @param {string} [priceMin] Minimum price
         * @param {string} [priceType] Filter by price type
         * @param {string} [product] Internal ID of the product
         * @param {string} [quantityMax] Maximum quantity
         * @param {string} [quantityMin] Minimum quantity
         * @param {string} [search] Filter by a set of keywords
         * @param {boolean} [sold] Filter by if the Listing is sold or not
         * @param {'ACT' | 'NSW' | 'NT' | 'QLD' | 'SA' | 'TAS' | 'VIC' | 'WA'} [state] Filter by state of the Listings. Multiple values must be comma separated  * &#x60;ACT&#x60; - Australian Capital Territory * &#x60;NSW&#x60; - New South Wales * &#x60;NT&#x60; - Northern Territory * &#x60;QLD&#x60; - Queensland * &#x60;SA&#x60; - South Australia * &#x60;TAS&#x60; - Tasmania * &#x60;VIC&#x60; - Victoria * &#x60;WA&#x60; - Western Australia
         * @param {string} [stockAge] Filter by Stock Age. Multiple values must be comma separated
         * @param {string} [stockCat] Filter by Stock Categories. Multiple values must be comma separated
         * @param {string} [stockGender] Filter by Stock Gender. Multiple values must be comma separated
         * @param {'BUY' | 'SELL'} [type] Filter by Listing type  * &#x60;SELL&#x60; - For sale * &#x60;BUY&#x60; - Wanted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketplaceListingList(aaSource?: string, anonymous?: boolean, auction?: boolean, bookmark?: string, network?: string, org?: string, page?: number, pageSize?: number, priceMax?: string, priceMin?: string, priceType?: string, product?: string, quantityMax?: string, quantityMin?: string, search?: string, sold?: boolean, state?: 'ACT' | 'NSW' | 'NT' | 'QLD' | 'SA' | 'TAS' | 'VIC' | 'WA', stockAge?: string, stockCat?: string, stockGender?: string, type?: 'BUY' | 'SELL', options?: any): AxiosPromise<PaginatedListingReadList> {
            return localVarFp.marketplaceListingList(aaSource, anonymous, auction, bookmark, network, org, page, pageSize, priceMax, priceMin, priceType, product, quantityMax, quantityMin, search, sold, state, stockAge, stockCat, stockGender, type, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint behaves the same as the Public Listing endpoint except for:  1. It is filtered by the Organisation in the path  2. If the Organisation is a Head Org then all Public Listings within it\'s Networks are also returned. 3. Anonymous Listings are filtered out.
         * @summary The public endpoint for retrieving all the current Public Listings filtered by the Org
         * @param {string} orgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {string} [bookmark] Filter by Bookmark Type. Choices: NEW, IGNORE, TRADE, WATCH. Multiple values must be comma separated
         * @param {string} [network] Filter by Network id. Multiple values must be comma separated. Use &#x60;all&#x60; to return Listings that are only shared with a Network.
         * @param {string} [org] Filter by Organisation id
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {number} [priceMax] Filter by pricing using a min and/or max value
         * @param {number} [priceMin] Filter by pricing using a min and/or max value
         * @param {string} [priceType] Filter by price type
         * @param {string} [product] Internal ID of the product
         * @param {string} [quantityMax] Filter by quantity using a min and/or max value
         * @param {string} [quantityMin] Filter by quantity using a min and/or max value
         * @param {string} [search] Filter by a set of keywords
         * @param {boolean} [sold] Filter by if the Listing is sold or not
         * @param {'ACT' | 'NSW' | 'NT' | 'QLD' | 'SA' | 'TAS' | 'VIC' | 'WA'} [state] Filter by state of the Listings. Multiple values must be comma separated  * &#x60;ACT&#x60; - Australian Capital Territory * &#x60;NSW&#x60; - New South Wales * &#x60;NT&#x60; - Northern Territory * &#x60;QLD&#x60; - Queensland * &#x60;SA&#x60; - South Australia * &#x60;TAS&#x60; - Tasmania * &#x60;VIC&#x60; - Victoria * &#x60;WA&#x60; - Western Australia
         * @param {string} [stockAge] Filter by Stock Age. Multiple values must be comma separated
         * @param {string} [stockCat] Filter by Stock Categories. Multiple values must be comma separated
         * @param {string} [stockGender] Filter by Stock Gender. Multiple values must be comma separated
         * @param {'BUY' | 'SELL'} [type] Filter by Listing type  * &#x60;SELL&#x60; - For sale * &#x60;BUY&#x60; - Wanted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketplaceListingOrgList(orgId: string, aaSource?: string, bookmark?: string, network?: string, org?: string, page?: number, pageSize?: number, priceMax?: number, priceMin?: number, priceType?: string, product?: string, quantityMax?: string, quantityMin?: string, search?: string, sold?: boolean, state?: 'ACT' | 'NSW' | 'NT' | 'QLD' | 'SA' | 'TAS' | 'VIC' | 'WA', stockAge?: string, stockCat?: string, stockGender?: string, type?: 'BUY' | 'SELL', options?: any): AxiosPromise<PaginatedListingReadList> {
            return localVarFp.marketplaceListingOrgList(orgId, aaSource, bookmark, network, org, page, pageSize, priceMax, priceMin, priceType, product, quantityMax, quantityMin, search, sold, state, stockAge, stockCat, stockGender, type, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary The public endpoint for retrieving the latest APPROVED version of the listing, otherwise 404
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketplaceListingRetrieve(listingId: string, aaSource?: string, options?: any): AxiosPromise<ListingRead> {
            return localVarFp.marketplaceListingRetrieve(listingId, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Should only be used when a view count needs to be added for a listing when it is not viewed via the standard GET:/v2/marketplace/listing/{listing_id} request  eg: from an agora embedded widget
         * @summary Add a view event for the listing
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketplaceListingVCreate(listingId: string, aaSource?: string, options?: any): AxiosPromise<void> {
            return localVarFp.marketplaceListingVCreate(listingId, aaSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for marketplaceListingBookmarkCreate operation in PublicMarketplaceListingApi.
 * @export
 * @interface PublicMarketplaceListingApiMarketplaceListingBookmarkCreateRequest
 */
export interface PublicMarketplaceListingApiMarketplaceListingBookmarkCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingBookmarkCreate
     */
    readonly listingId: string

    /**
     * 
     * @type {ListingBookmarkRequest}
     * @memberof PublicMarketplaceListingApiMarketplaceListingBookmarkCreate
     */
    readonly listingBookmarkRequest: ListingBookmarkRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingBookmarkCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for marketplaceListingEnquiryCreate operation in PublicMarketplaceListingApi.
 * @export
 * @interface PublicMarketplaceListingApiMarketplaceListingEnquiryCreateRequest
 */
export interface PublicMarketplaceListingApiMarketplaceListingEnquiryCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingEnquiryCreate
     */
    readonly listingId: string

    /**
     * 
     * @type {ListingEnquiryCreateRequest}
     * @memberof PublicMarketplaceListingApiMarketplaceListingEnquiryCreate
     */
    readonly listingEnquiryCreateRequest: ListingEnquiryCreateRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingEnquiryCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for marketplaceListingList operation in PublicMarketplaceListingApi.
 * @export
 * @interface PublicMarketplaceListingApiMarketplaceListingListRequest
 */
export interface PublicMarketplaceListingApiMarketplaceListingListRequest {
    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingList
     */
    readonly aaSource?: string

    /**
     * Filter anonymous listings.
     * @type {boolean}
     * @memberof PublicMarketplaceListingApiMarketplaceListingList
     */
    readonly anonymous?: boolean

    /**
     * Filter by if the Listing is an auction or not
     * @type {boolean}
     * @memberof PublicMarketplaceListingApiMarketplaceListingList
     */
    readonly auction?: boolean

    /**
     * Filter by Bookmark Type. Choices: NEW, IGNORE, TRADE, WATCH. Multiple values must be comma separated
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingList
     */
    readonly bookmark?: string

    /**
     * Filter by Network id. Multiple values must be comma separated. Use &#x60;all&#x60; to return Listings that are only shared with a Network.
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingList
     */
    readonly network?: string

    /**
     * Filter by Organisation id
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingList
     */
    readonly org?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof PublicMarketplaceListingApiMarketplaceListingList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof PublicMarketplaceListingApiMarketplaceListingList
     */
    readonly pageSize?: number

    /**
     * Maximum price
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingList
     */
    readonly priceMax?: string

    /**
     * Minimum price
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingList
     */
    readonly priceMin?: string

    /**
     * Filter by price type
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingList
     */
    readonly priceType?: string

    /**
     * Internal ID of the product
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingList
     */
    readonly product?: string

    /**
     * Maximum quantity
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingList
     */
    readonly quantityMax?: string

    /**
     * Minimum quantity
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingList
     */
    readonly quantityMin?: string

    /**
     * Filter by a set of keywords
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingList
     */
    readonly search?: string

    /**
     * Filter by if the Listing is sold or not
     * @type {boolean}
     * @memberof PublicMarketplaceListingApiMarketplaceListingList
     */
    readonly sold?: boolean

    /**
     * Filter by state of the Listings. Multiple values must be comma separated  * &#x60;ACT&#x60; - Australian Capital Territory * &#x60;NSW&#x60; - New South Wales * &#x60;NT&#x60; - Northern Territory * &#x60;QLD&#x60; - Queensland * &#x60;SA&#x60; - South Australia * &#x60;TAS&#x60; - Tasmania * &#x60;VIC&#x60; - Victoria * &#x60;WA&#x60; - Western Australia
     * @type {'ACT' | 'NSW' | 'NT' | 'QLD' | 'SA' | 'TAS' | 'VIC' | 'WA'}
     * @memberof PublicMarketplaceListingApiMarketplaceListingList
     */
    readonly state?: 'ACT' | 'NSW' | 'NT' | 'QLD' | 'SA' | 'TAS' | 'VIC' | 'WA'

    /**
     * Filter by Stock Age. Multiple values must be comma separated
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingList
     */
    readonly stockAge?: string

    /**
     * Filter by Stock Categories. Multiple values must be comma separated
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingList
     */
    readonly stockCat?: string

    /**
     * Filter by Stock Gender. Multiple values must be comma separated
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingList
     */
    readonly stockGender?: string

    /**
     * Filter by Listing type  * &#x60;SELL&#x60; - For sale * &#x60;BUY&#x60; - Wanted
     * @type {'BUY' | 'SELL'}
     * @memberof PublicMarketplaceListingApiMarketplaceListingList
     */
    readonly type?: 'BUY' | 'SELL'
}

/**
 * Request parameters for marketplaceListingOrgList operation in PublicMarketplaceListingApi.
 * @export
 * @interface PublicMarketplaceListingApiMarketplaceListingOrgListRequest
 */
export interface PublicMarketplaceListingApiMarketplaceListingOrgListRequest {
    /**
     * 
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingOrgList
     */
    readonly orgId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingOrgList
     */
    readonly aaSource?: string

    /**
     * Filter by Bookmark Type. Choices: NEW, IGNORE, TRADE, WATCH. Multiple values must be comma separated
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingOrgList
     */
    readonly bookmark?: string

    /**
     * Filter by Network id. Multiple values must be comma separated. Use &#x60;all&#x60; to return Listings that are only shared with a Network.
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingOrgList
     */
    readonly network?: string

    /**
     * Filter by Organisation id
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingOrgList
     */
    readonly org?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof PublicMarketplaceListingApiMarketplaceListingOrgList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof PublicMarketplaceListingApiMarketplaceListingOrgList
     */
    readonly pageSize?: number

    /**
     * Filter by pricing using a min and/or max value
     * @type {number}
     * @memberof PublicMarketplaceListingApiMarketplaceListingOrgList
     */
    readonly priceMax?: number

    /**
     * Filter by pricing using a min and/or max value
     * @type {number}
     * @memberof PublicMarketplaceListingApiMarketplaceListingOrgList
     */
    readonly priceMin?: number

    /**
     * Filter by price type
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingOrgList
     */
    readonly priceType?: string

    /**
     * Internal ID of the product
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingOrgList
     */
    readonly product?: string

    /**
     * Filter by quantity using a min and/or max value
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingOrgList
     */
    readonly quantityMax?: string

    /**
     * Filter by quantity using a min and/or max value
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingOrgList
     */
    readonly quantityMin?: string

    /**
     * Filter by a set of keywords
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingOrgList
     */
    readonly search?: string

    /**
     * Filter by if the Listing is sold or not
     * @type {boolean}
     * @memberof PublicMarketplaceListingApiMarketplaceListingOrgList
     */
    readonly sold?: boolean

    /**
     * Filter by state of the Listings. Multiple values must be comma separated  * &#x60;ACT&#x60; - Australian Capital Territory * &#x60;NSW&#x60; - New South Wales * &#x60;NT&#x60; - Northern Territory * &#x60;QLD&#x60; - Queensland * &#x60;SA&#x60; - South Australia * &#x60;TAS&#x60; - Tasmania * &#x60;VIC&#x60; - Victoria * &#x60;WA&#x60; - Western Australia
     * @type {'ACT' | 'NSW' | 'NT' | 'QLD' | 'SA' | 'TAS' | 'VIC' | 'WA'}
     * @memberof PublicMarketplaceListingApiMarketplaceListingOrgList
     */
    readonly state?: 'ACT' | 'NSW' | 'NT' | 'QLD' | 'SA' | 'TAS' | 'VIC' | 'WA'

    /**
     * Filter by Stock Age. Multiple values must be comma separated
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingOrgList
     */
    readonly stockAge?: string

    /**
     * Filter by Stock Categories. Multiple values must be comma separated
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingOrgList
     */
    readonly stockCat?: string

    /**
     * Filter by Stock Gender. Multiple values must be comma separated
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingOrgList
     */
    readonly stockGender?: string

    /**
     * Filter by Listing type  * &#x60;SELL&#x60; - For sale * &#x60;BUY&#x60; - Wanted
     * @type {'BUY' | 'SELL'}
     * @memberof PublicMarketplaceListingApiMarketplaceListingOrgList
     */
    readonly type?: 'BUY' | 'SELL'
}

/**
 * Request parameters for marketplaceListingRetrieve operation in PublicMarketplaceListingApi.
 * @export
 * @interface PublicMarketplaceListingApiMarketplaceListingRetrieveRequest
 */
export interface PublicMarketplaceListingApiMarketplaceListingRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingRetrieve
     */
    readonly listingId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingRetrieve
     */
    readonly aaSource?: string
}

/**
 * Request parameters for marketplaceListingVCreate operation in PublicMarketplaceListingApi.
 * @export
 * @interface PublicMarketplaceListingApiMarketplaceListingVCreateRequest
 */
export interface PublicMarketplaceListingApiMarketplaceListingVCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingVCreate
     */
    readonly listingId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof PublicMarketplaceListingApiMarketplaceListingVCreate
     */
    readonly aaSource?: string
}

/**
 * PublicMarketplaceListingApi - object-oriented interface
 * @export
 * @class PublicMarketplaceListingApi
 * @extends {BaseAPI}
 */
export class PublicMarketplaceListingApi extends BaseAPI {
    /**
     * Allow external IDs to be used for generic API views.
     * @summary Create or update a Bookmark against the Listing.
     * @param {PublicMarketplaceListingApiMarketplaceListingBookmarkCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicMarketplaceListingApi
     */
    public marketplaceListingBookmarkCreate(requestParameters: PublicMarketplaceListingApiMarketplaceListingBookmarkCreateRequest, options?: any) {
        return PublicMarketplaceListingApiFp(this.configuration).marketplaceListingBookmarkCreate(requestParameters.listingId, requestParameters.listingBookmarkRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary Create a new Enquiry for a Listing.
     * @param {PublicMarketplaceListingApiMarketplaceListingEnquiryCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicMarketplaceListingApi
     */
    public marketplaceListingEnquiryCreate(requestParameters: PublicMarketplaceListingApiMarketplaceListingEnquiryCreateRequest, options?: any) {
        return PublicMarketplaceListingApiFp(this.configuration).marketplaceListingEnquiryCreate(requestParameters.listingId, requestParameters.listingEnquiryCreateRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary The public endpoint for retrieving all the current public listings.
     * @param {PublicMarketplaceListingApiMarketplaceListingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicMarketplaceListingApi
     */
    public marketplaceListingList(requestParameters: PublicMarketplaceListingApiMarketplaceListingListRequest = {}, options?: any) {
        return PublicMarketplaceListingApiFp(this.configuration).marketplaceListingList(requestParameters.aaSource, requestParameters.anonymous, requestParameters.auction, requestParameters.bookmark, requestParameters.network, requestParameters.org, requestParameters.page, requestParameters.pageSize, requestParameters.priceMax, requestParameters.priceMin, requestParameters.priceType, requestParameters.product, requestParameters.quantityMax, requestParameters.quantityMin, requestParameters.search, requestParameters.sold, requestParameters.state, requestParameters.stockAge, requestParameters.stockCat, requestParameters.stockGender, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint behaves the same as the Public Listing endpoint except for:  1. It is filtered by the Organisation in the path  2. If the Organisation is a Head Org then all Public Listings within it\'s Networks are also returned. 3. Anonymous Listings are filtered out.
     * @summary The public endpoint for retrieving all the current Public Listings filtered by the Org
     * @param {PublicMarketplaceListingApiMarketplaceListingOrgListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicMarketplaceListingApi
     */
    public marketplaceListingOrgList(requestParameters: PublicMarketplaceListingApiMarketplaceListingOrgListRequest, options?: any) {
        return PublicMarketplaceListingApiFp(this.configuration).marketplaceListingOrgList(requestParameters.orgId, requestParameters.aaSource, requestParameters.bookmark, requestParameters.network, requestParameters.org, requestParameters.page, requestParameters.pageSize, requestParameters.priceMax, requestParameters.priceMin, requestParameters.priceType, requestParameters.product, requestParameters.quantityMax, requestParameters.quantityMin, requestParameters.search, requestParameters.sold, requestParameters.state, requestParameters.stockAge, requestParameters.stockCat, requestParameters.stockGender, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary The public endpoint for retrieving the latest APPROVED version of the listing, otherwise 404
     * @param {PublicMarketplaceListingApiMarketplaceListingRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicMarketplaceListingApi
     */
    public marketplaceListingRetrieve(requestParameters: PublicMarketplaceListingApiMarketplaceListingRetrieveRequest, options?: any) {
        return PublicMarketplaceListingApiFp(this.configuration).marketplaceListingRetrieve(requestParameters.listingId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Should only be used when a view count needs to be added for a listing when it is not viewed via the standard GET:/v2/marketplace/listing/{listing_id} request  eg: from an agora embedded widget
     * @summary Add a view event for the listing
     * @param {PublicMarketplaceListingApiMarketplaceListingVCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicMarketplaceListingApi
     */
    public marketplaceListingVCreate(requestParameters: PublicMarketplaceListingApiMarketplaceListingVCreateRequest, options?: any) {
        return PublicMarketplaceListingApiFp(this.configuration).marketplaceListingVCreate(requestParameters.listingId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }
}
